import * as React from "react";
import { Button } from "antd";

type Props = {
  isDisabled: boolean;
  onClick?: () => void;
  icon: React.JSXElementConstructor<React.StyleHTMLAttributes<{}>>;
  href?: string;
  target?: string;
};

export const ForwardOutlineButton: React.FC<Props> = props => {
  const { isDisabled, onClick, icon: Icon, href, target } = props;
  return (
    <Button
      style={{
        width: 40,
        height: 40,
        backgroundColor: isDisabled ? "#9da6b1" : "#386ee8",
        padding: "6px 0",
        borderRadius: 0,
        border: "none",
        boxShadow: "0 3px 6px 0 rgba(0, 0, 0, 0.16)"
      }}
      disabled={isDisabled}
      onClick={onClick}
      href={href}
      target={target}
    >
      <Icon style={{ height: "100%" }} />
    </Button>
  );
};
